"use client";

import React from "react";
import { Leaf, Flame, Coffee } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const alchemySteps = [{
  numeral: "01",
  title: "The Discovery Call",
  description: "Connect with Olivia, our AI voice agent, for a 15-minute deep dive into your current workflows and time-consuming manual bottlenecks.",
  Icon: Leaf
}, {
  numeral: "02",
  title: "The AI Analysis",
  description: "Our proprietary algorithms cross-reference your operations against 500+ AI automation patterns to identify your specific 'Hidden Hours'.",
  Icon: Flame
}, {
  numeral: "03",
  title: "The Roadmap",
  description: "Receive your personalized AI Assessment within 48 hours, detailing exactly how to recoup your time and scale efficiently.",
  Icon: Coffee
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="226208" id="how-it-works" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="mb-20 text-center md:text-left">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight mb-4 text-foreground">
            How It Works
          </h2>
          <div className="h-px w-24 bg-primary mx-auto md:mx-0"></div>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {alchemySteps.map((step, i) => <div key={step.numeral} data-index={i} className="relative flex flex-col pt-12 group">
              {}
              <span className="absolute -top-4 -left-4 text-[8rem] md:text-[10rem] lg:text-[12rem] font-default font-bold text-primary/10 select-none leading-none z-0 transition-colors duration-500 group-hover:text-primary/20">
                {step.numeral}
              </span>

              {}
              <div className="relative z-10 flex flex-col items-start">
                <div className="mb-8 p-3 rounded-lg bg-secondary border border-border group-hover:border-primary/50 transition-colors duration-300">
                  <step.Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-default font-bold mb-4 text-foreground tracking-tight">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed font-default text-sm md:text-base">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}